<template>
  <div class="carSetting">
    <div class="carCon">
      <div class="carInfo">
          <img class="carImg" :src="carInfo.ImgUrl || defaultCarImg"/>
          <div class="carinfo">
            <span class="carname">{{carInfo.CarNumber}}</span>
            <span>{{carInfo.CarClass}}</span>
            <span class="shopname">所在门店{{shopInfo.Name}}</span>
          </div>
      </div>
    </div>
    <div class="content">
      <div class="mark">
        <div class="stateCon">
          <div class="vo">
            <span class="value">{{carInfo.Mileage}}</span>
            <span class="key">共享里程(KM)</span>
          </div>
          <div class="vo">
            <span class="value">{{carInfo.OnlineDays}}</span>
            <span class="key">共享天数</span>
          </div>
          <div class="vo">
            <span class="value">{{carInfo.Status}}</span>
            <span class="key">车辆状态</span>
          </div>
        </div>
        <div class="accidentCon">
          <div class="item">
            <div class="title">
              <span>车辆违章</span>
              <span class="arrow"  @click="goPeccancy()"></span>
            </div>
            <ul class="carStatus">
              <li>
                <span class="value">{{peccancyInfo.Processing}}</span>
                <span class="key">处理中</span>
              </li>
              <li>
                <span class="value">{{peccancyInfo.Finish}}</span>
                <span class="key">已完结</span>
              </li>
            </ul>
          </div>
          <div class="item">
            <div class="title">
              <span>车辆事故</span>
              <span class="arrow"  @click="goAccident()"></span>

            </div>
            <ul class="carStatus">
              <li>
                <span class="value">{{accidentInfo.Processing}}</span>
                <span class="key">处理中</span>
              </li>
              <li>
                <span class="value">{{accidentInfo.finish}}</span>
                <span class="key">已完结</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="maintainCon">
          <div class="title">
            <span>车辆赠送保养服务</span>
            <span class="arrow"  @click="goMaintain()"></span>
          </div>
          <div class="maintainShow">
            <span>累计免费保养次数</span>
            <span class="value">{{freeMaintainCount}}</span>
          </div>
        </div>
        <div class="dateCon">
          <div class="top">
            <div class="title">可租时间</div>
            <div class="date" @click="goCalendar()">1-60天 <img class="ico" src="@/assets/images/carSetting/arrow_right.png"/></div>
          </div>
          <div class="middle">
            <div class="weekTitle">
              <div class="week" v-for="(item,index) in weekList" :key="index">{{item}}</div>
            </div>
            <div class="days">
              <div v-for="(item,index) in rentdays" :key="index">
                <div class="noday" v-if="JSON.stringify(item) == '{}'"></div>
                <div :class="['day',item.Status == 3 ? 'noRent' : '',item.Status == 2 ? 'partlyRented' : '']" v-else>
                  <span>{{item.RentDate}}</span>
                  <span class="blue">￥{{item.Price}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="status">
              <img class="statusIco" src="@/assets/images/carSetting/ico3.png"/>可租
            </div>
            <div class="status">
              <img class="statusIco" src="@/assets/images/carSetting/ico2.png"/>部分时间可租
            </div>
            <div class="status">
              <img class="statusIco" src="@/assets/images/carSetting/ico1.png"/>不可租
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getDay ,setWeek} from "@/utils/formatDate";
import { getcarInfo } from "@/utils/api";
export default {
  name: "carSetting",
  data: function() {
    return {
      ID:0,
      freeMaintainCount: 0, //累计保养次数
      carInfo: {
        CarNumber: "鄂A00000",
        CarClass: "车辆名称",
        Mileage: 0,
        OnlineDays: 0,
        Status: "其他"
      },
      defaultCarImg: "/static/images/index/car.png",
      shopInfo: {},
      peccancyInfo: {
        Processing: 0,
        Finish: 0
      },
      accidentInfo: {
        Processing: 0,
        finish: 0
      },
      weekList: ["日", "一", "二", "三", "四", "五", "六"],
      rentdays: []
    };
  },
  components: {},
  created() {
    this.ID = this.$route.query.ID || 0;
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      let res = await getcarInfo({
        data: {
          ID: this.ID
        }
      });
      if (res.Code == 100) {
        switch (res.Data.CarInfo.Status) {
          case 1:
            res.Data.CarInfo.Status = "待审核";
            break;
          case 3:
            res.Data.CarInfo.Status = "待上线";
            break;
          case 4:
            res.Data.CarInfo.Status = "已拒绝";
            break;
          case 5:
            res.Data.CarInfo.Status = "待租";
            if( res.Data.CarInfo.AutoStatusName && res.Data.CarInfo.AutoStatusName!='' ){
              res.Data.CarInfo.Status = res.Data.CarInfo.AutoStatusName;
            }
            break;
          case 6:
            res.Data.CarInfo.Status = "已下线";
            break;
          default:
            res.Data.CarInfo.Status = "其他";
        }

        let date = res.Data.rentDays[0].RentDate.slice(0, 10);
        let day = getDay(date) == 6 ? 0 : getDay(date);

        for (var i = 0; i < res.Data.rentDays.length; i++) {
          let week = setWeek(res.Data.rentDays[i].RentDate.slice(0,10));
          res.Data.rentDays[i].RentDate = res.Data.rentDays[i].RentDate.slice(8, 10);
          this.rentdays.push(res.Data.rentDays[i]);
          if(week == '周六'){
            break;
          }
        }
        for (let i = day; i > 0; i--) {
          this.rentdays.unshift({});
        }
        this.freeMaintainCount = res.Data.freeMaintainCount;
        this.carInfo = res.Data.CarInfo;
        this.shopInfo = res.Data.ShopInfo;
        this.peccancyInfo = res.Data.PeccancyInfo;
        this.accidentInfo = res.Data.AccidentInfo;
      }
    },
    goCalendar() {
      this.$router.replace({ path: "/calendar" ,query:{CarID:this.carInfo.CarID}});
    },
    goMaintain() {
      this.$router.replace({ path: "/maintain" ,query:{CarID:this.carInfo.CarID}});
    },
    goAccident() {
      this.$router.replace({ path: "/accident" ,query:{CarID:this.carInfo.CarID}});
    },
    goPeccancy() {
      this.$router.replace({ path: "/peccancy" ,query:{CarID:this.carInfo.CarID}});
    }
  }
};
</script>

<style  scoped lang="scss" type="text/scss">
.carSetting {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: auto;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  padding-top: 110px;
  box-sizing: border-box;
  background: url("~@/assets/images/user/walletBg.png") no-repeat 0 0;
  background-size: 100% 559px;
  .carCon {
    padding: 20px 80px 70px;
    color: #fff;
    .carInfo {
      display: flex;
      height: 120px;
      .carImg {
        width: 185px;
        height: 104px;
      }
      .carinfo {
        display: flex;
        flex-direction: column;
        margin-left: 20px;
        margin-top: -8px;
        .carname {
          font-size: 34px;
          font-weight: bold;
        }
        .shopname {
          margin-top: 10px;
        }
      }
    }
  }
  .content {
    padding: 0 40px;
    box-sizing: border-box;
    background: #fff;
    .mark {
      position: relative;
      bottom: 85px;
      width: 670px;

      .stateCon {
        display: flex;
        justify-content: space-between;
        padding: 20px 0;
        margin-top: 20px;
        box-sizing: border-box;
        background: #fff;
        box-shadow: -3px 6px 15px #ccc;
        -webkit-box-shadow:-3px 6px 15px #ccc ;
        border-radius: 20px;
        .vo {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 5px 0;
          box-sizing: border-box;
          text-align: center;
          border-right: 1px solid #e7e6e6;/*no*/
          height: 106px;
          min-width: 210px;
          &:last-child {
            border: none;
          }
          .value {
            font-size: 34px;
            font-weight: bold;
            color: #027fff;
          }
          .key {
            color: #797979;
          }
        }
      }
      .accidentCon {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .item {
          padding: 10px 0;
          box-sizing: border-box;
          box-shadow: 0 0 6px #ccc;
          -webkit-box-shadow:0 0 6px #ccc ;
          border-radius: 6px;
          .title {
            display: flex;
            justify-content: space-between;
            padding: 10px;
            box-sizing: border-box;
            border-left: 10px solid #027fff;
            font-size: 34px;
            font-weight: bold;
          }
          .carStatus {
            display: flex;
            justify-content: space-between;
            padding: 10px 15px;
            box-sizing: border-box;
            li {
              display: flex;
              flex-direction: column;
              padding: 10px 37px;
              box-sizing: border-box;
              text-align: center;
              border-right: 1px solid #e7e6e6;/*no*/
              &:last-child {
                border: none;
              }
              .key {
                color: #797979;
              }
              .value {
                color: #027fff;
                font-size: 36px;
                font-weight: bold;
              }
            }
          }
        }
      }
      .maintainCon {
        margin-top: 20px;
        padding: 20px 0;
        box-sizing: border-box;
        box-shadow: 0 0 6px #ccc;
        -webkit-box-shadow:0 0 6px #ccc ;
        .title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px;
          box-sizing: border-box;
          border-left: 10px solid #027fff;
          font-size: 34px;
          font-weight: bold;
        }
        .maintainShow {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 20px;
          box-sizing: border-box;
          color: #797979;
          .value {
            color: #027fff;
            font-size: 36px;
            font-weight: bold;
          }
        }
      }
      .dateCon {
        padding: 25px 0;
        margin-top: 30px;
        box-sizing: border-box;
        height: 400px;
        border: 2px solid #027fff;
        .top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-right: 35px;
          box-sizing: border-box;
          color: #027fff;
          font-size: 26px;
          .title {
            padding-left: 34px;
            margin-bottom: 20px;
            box-sizing: border-box;
            border-left: 10px solid #027fff;
            font-size: 34px;
            color: #000;
            font-weight: bold;
          }
          .date {
            display: flex;
            align-items: center;
            .ico {
              width: 30px;
              height: 30px;
              margin-left: 10px;
            }
          }
        }
        .middle {
          padding: 0 35px;
          box-sizing: border-box;
          height: 200px;
          .weekTitle {
            display: flex;
            justify-content: space-around;
            padding: 50px 0 20px 0;
            box-sizing: border-box;
            color: #9f9f9f;
            font-size: 26px;
          }
          .days {
            display: flex;
            .noday {
              width: 80px;
              margin: 3px;
            }
            .day {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              margin: 3px;
              width: 78px;
              height: 90px;

              border: 1px dashed #9f9f9f;/*no*/
              box-sizing: border-box;
              span {
                display: flex;
                justify-content: center;
              }
              .blue {
                color: #027fff;
                font-weight: bold;
                font-size: 22px;
              }
            }
            .noRent {
              background: #ebebeb;
            }
            .partlyRented {
              background-image: -webkit-linear-gradient(
                top,
                #ebebeb 50%,
                #ffffff 0%
              );
            }
          }
        }
        .bottom {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-top: 30px;
          color: #9f9f9f;
          font-size: 26px;
          .status {
            display: flex;
            align-items: center;
            margin-right: 30px;
            .statusIco {
              margin-right: 10px;
              width: 40px;
              height: 40px;
            }
          }
        }
      }
      .arrow{
        width: 150px !important;
        height: 40px;
        background: url("~@/assets/images/carSetting/arrow_right.png") no-repeat 120px 0;
        background-size: contain;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/car/carSetting.vue